/**
 * Pure formatting helpers — geen DOM-toegang, geen state.
 */

import { i18n } from '../i18n/nl';

/**
 * Mens-leesbare bytes. NaN/negative → "Onbekend" i.p.v. misleidend "0 B".
 */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return i18n.misc.fileSizeUnknown;
  if (bytes === 0) return '0 B';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
